var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NotFound"}},[_c('h1',[_vm._v("Error 404")]),_c('p',[_vm._v(_vm._s(this.$router.currentRoute.path))])])}
var staticRenderFns = []

export { render, staticRenderFns }